import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import utils from '@/global/utils';
import log from '@/global/log';
import Vue3Lottie from 'vue3-lottie';
import VueDragscroll from 'vue-dragscroll';

// 아이콘 폰트 스타일
import './assets/scss/style.css';
const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueDragscroll);
app.use(Vue3Lottie);
app.config.globalProperties.$utils = utils; // [utils ]
app.config.globalProperties.$log = log; // [log ]

//component
import Layout from './components/Layout.vue';
import Dim from './components/Dim.vue';
import CustomBtn from './components/CustomBtn.vue';
import DashBtn from './components/DashBtn.vue';
import ZoomImg from './components/ZoomImg.vue';

app.component('Layout', Layout);
app.component('Dim', Dim);
app.component('CustomBtn', CustomBtn);
app.component('DashBtn', DashBtn);
app.component('ZoomImg', ZoomImg);

app.mount('#app');
